import { PRIVACY_CONTENT_TYPE } from "./common";

export const PRIVACY_CONTENT = {
  CONTENT_KO: [
    {
      title: "kps 개인정보처리방침",
      lastUpdate: "마지막 업데이트: 2025년 03월 11일 00:00",
      description:
        'kps(www.kps.com)를 운영하는 ㈜두아즈(이하 "당사")는 "정보통신망 이용촉진 및 정보보호 등에 관한 법률"에 따라서 해당 법률을 준수하고 있습니다.' +
        "'당사'는 개인정보보호법에 따라 '사용자'의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 '사용자'의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.\n" +
        "이후 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다. \n",
    },
    {
      title: "제1조. 개인정보의 처리 목적",
      description:
        "당사는 개인정보를 안전하게 보호하고, 권익에 침해되지 않도록 보관해야 한다는 방침에 따라 최선을 다해 노력하고 있습니다. 개인정보는 회원가입, 원활한 고객상담, 유료서비스 등 제공을 위해 활용되며, 개인정보처리방침을 통해 당사가 어떤 정보를 수집하고, 수집한 정보를 어떻게 사용하며, 필요에 따라 누구와 이를 공유(‘위탁 또는 제공’)하며 이용목적을 달성한 정보를 언제, 어떻게 파기하는지 등 ‘개인정보보호’와 관련한 정보를 투명하게 제공하는 것을 목적으로 두고 있습니다. 향후, 서비스 약관 변경 및 개인 정보 추가 수집 등 관련된 개인정보처리방침이 개정될 시에는 웹 사이트 공지사항 또는 메일을 통한 개별 안내를 통하여 개정된 내용을 알기 쉽게 공지할 것입니다.",
    },
    {
      title: "제2조. 개인정보의 수집항목 및 수집방법",
      description:
        "당사는 회원가입 또는 서비스 제공을 위해 회원의 개인정보를 수집하고 있으며, 수집하는 개인정보 항목에 따른 구체적인 수집항목 및 방법은 다음과 같습니다. \n \n" +
        "1. 수집하는 개인정보의 항목 \n" +
        "a. 당사는 최초 회원 가입시 아래와 같은 최소한의 개인정보를 필수항목으로 수집하고 있습니다. \n" +
        "필수항목 : 이메일 주소, 이름, ID , 비밀번호, 전화번호 \n" +
        "2. 개인정보 수집방법 \n" +
        "a. 당사는 다음과 같은 방법으로 개인정보를 수집합니다. \n" +
        "홈페이지, 서면양식, 전화, 이메일, 이벤트 툴, 상담 툴 \n" +
        "제3조. 개인정보의 수집 및 이용목적 \n" +
        "당사는 회원가입을 통해서 수집한 회원님의 개인정보를 다음과 같은 목적에 따라서 활용함을 명시합니다.",
    },
    {
      title: "제3조. 개인정보의 수집 및 이용목적",
      description:
        "당사는 회원가입을 통해서 수집한 회원님의 개인정보를 다음과 같은 목적에 따라서 활용함을 명시합니다. \n" +
        "1. 회원관리 \n" +
        "2. 서비스 제공 및 개선, 개인식별, 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한, 만14세 미만 아동의 개인정보 수집 시 법정 대리인 동의여부 확인, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달, 회원탈퇴 의사의 확인 등 \n" +
        "3. 법적 분쟁시 증거자료 제출",
    },
    {
      title: "제4조. 개인정보 수집 동의",
      description:
        "회원가입 시 회원님께서 충분히 개인정보취급방침을 확인할 수 있도록 표기하고, 동의한 이후에 가입할 수 있도록 환경을 조성합니다. 회원가입을 완료한 모든 회원은 상기 모든 개인정보 수집 절차 및 이용 목적에 동의한 것으로 간주합니다.",
    },
    {
      title: "제 5조. 개인정보의 파기 절차 및 방법",
      description:
        "당사는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기 절차 및 방법은 다음과 같습니다. \n" +
        "1. 파기절차 \n" +
        'a. "사용자"가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다. \n' +
        "2. 파기방법 \n" +
        "a. 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. \n" +
        "b. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. \n",
    },
    {
      title: "제 6조. 개인정보 위탁",
      type: PRIVACY_CONTENT_TYPE.TABLE,
      description:
        "1. 당사 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다." +
        "2. 당사는 위탁계약 체결시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. \n" +
        "3. 본 개인정보처리방침에 따른 위탁업무의 내용이나 수탁자가 변경될 경우에 당사는 변경 사항을 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다. \n",
      tableContent: [
        {
          company: "위탁 받는 자",
          details: "위탁 업무 내용",
        },
      ],
    },
    {
      title: '제7조. "사용자" 및 법정대리인의 권리와 그 행사방법',
      description:
        '1. "사용자" 및 법정대리인은 언제든지 등록되어 있는 자신 혹은 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며, 가입해지를 요청할 수도 있습니다. 고객센터에 회원이 탈퇴 신청 메일을 보낼 경우 회원 본인임을 확인한 후 탈퇴 처리를 합니다. \n' +
        '2. 당사는 "사용자"의 요청에 의해 해지 또는 삭제된 개인정보를 "사용자" 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보를 "제 5조 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다. \n' +
        "3. 법정대리인 등의 대리인을 통하여 제1항의 권리행사를 하는 경우 개인정보보호법 시행규칙 별표 제11호 서식에 따른 위임장을 제출하여야 합니다. \n" +
        "4. 개인정보의 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 제한될 수 있고, 정정 및 삭제요구도 대른 법령에서 그 개인정보가 수집대상으로 명시되어 있는 경우 그 삭제를 요구할 수 없습니다. \n",
    },
    {
      title: "제8조. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항",
      description:
        "kps는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. \n" +
        '쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 "사용자"의 컴퓨터 브라우저에게 보내는 소량의 정보이며 "사용자"들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다. \n' +
        '1. 쿠키의 사용 목적 : "사용자"가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 "사용자"에게 최적화된 정보 제공을 위해 사용됩니다. \n' +
        "2. 쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다. \n" +
        "3. 쿠키 저장을 거부할 경우 서비스 이용에 어려움이 발생할 수 있습니다.",
    },
    {
      title: "제9조. 개인정보의 안전성 확보 조치",
      description:
        "당사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다. \n" +
        "1. 개인정보 취급 직원의 최소화 및 교육 \n" +
        "a. 개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다. \n" +
        "2. 해킹 등에 대비한 기술적 대책 \n" +
        "a. 당사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다. \n" +
        '3. 개인정보의 암호화 a. "사용자"의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다. \n' +
        "4. 개인정보에 대한 접근 제한 \n" +
        "a. 개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다. \n",
    },
    {
      title: "제10조. 개인정보 처리방침 변경 고지",
      description:
        "상기 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 최소 7일 전부터 공지사항을 통하여 고지할 것입니다.",
    },
    {
      title: "제11조. 개인정보 관리 책임자 및 담당자",
      description:
        "당사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. \n" +
        "1. 개인정보관리 담당부서 : 고객지원팀 \n" +
        "a. 이메일: doazpeople@gmail.com \n" +
        "2. 개인정보관리책임자 성명: 김영태 \n" +
        "a. 전화번호: 02-6204-0139 \n" +
        "회원님은 당사 및 당사의 서비스(kps)를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. \n" +
        "기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다. \n" +
        "개인정보 침해신고센터 (https://privacy.kisa.or.kr/kor/main.jsp / 국번없이 118) \n" +
        "대검찰청 인터넷범죄수사센터 (http://www.spo.go.kr / 02-3480-2000) \n" +
        "경찰청 사이버안전국( http://cyberbureau.police.go.kr / 국번없이 182) \n" +
        "본 정책은 2025년 03월 11일부터 시행됩니다.",
    },
  ],
  CONTENT_EN: [
    {
      title: "kps Privacy Policy",
      lastUpdate: "Last Updated :March 11, 2025 00:00",
      description:
        "kps(www.kps.com)kps Co., Ltd. (hereinafter “our company”), which operates , complies with the relevant laws in accordance with the “Act on Promotion of Information and Communications Network Utilization and Information Protection, etc." +
        "In accordance with the Personal Information Protection Act, 'our company' has the following processing policy in place to protect the personal information and rights of 'users' and to smoothly handle 'users' grievances related to personal information.\n" +
        "If the personal information processing policy is revised in the future, it will be announced through website notices (or individual notices). \n",
    },
    {
      title: "Article 1. Purpose of Processing Personal Information",
      description:
        "We are committed to making every effort to securely protect personal information and ensure it is not infringed upon. Personal information is utilized for purposes such as membership registration, smooth customer consultation, and the provision of paid services. Through our Privacy Policy, we aim to transparently provide information related to 'personal information protection,' including what information we collect, how we use the collected information, with whom we share it (entrust or provide), and when and how we destroy information once its purpose is achieved. In the future, if there are any revisions to the service terms or additional collection of personal information, we will notify you of the revised content through website announcements or individual notifications via email.",
    },
    {
      title:
        "Article 2. Items of Personal Information Collected and Collection",
      description:
        "We collect personal information of members for membership registration or service provision, and the specific items and methods of collection according to the collected personal information items are as follows. \n \n" +
        "1. Items of Personal Information Collected \n" +
        "a. We collect the following minimum personal information as mandatory items during initial membership registration. \n" +
        "Mandatory items: Email address, name, ID, password, phone number \n" +
        "2. Methods of Collecting Personal Information \n" +
        "a. We collect personal information using the following methods: \n" +
        "Website, written forms, phone, email, event tools, consultation tools \n" +
        "Article 3. Purpose of Collection and Use of Personal Information \n" +
        "We specify that the personal information of members collected through membership registration is utilized for the following purposes.",
    },
    {
      title: "Article 3. Purpose of Collection and Use of Personal Information",
      description:
        "We specify that the personal information of members collected through membership registration is utilized for the following purposes:  \n" +
        "1. Member Management \n" +
        "2. Providing and improving services, personal identification, taking measures to restrict the use of members who violate the terms of use, sanctioning actions that interfere with the smooth operation of the service and fraudulent use of the service, confirming membership intention, limiting membership and membership frequency, verifying the consent of legal guardians when collecting personal information of children under 14, subsequent verification of legal guardians, record preservation for dispute resolution, handling complaints and civil affairs, delivering notices, confirming the intention to withdraw membership, etc. \n" +
        "3. Submitting evidence in case of legal disputes.",
    },
    {
      "title": "Article 4. Consent to Collection of Personal Information",
      "description": "During membership registration, we ensure that members have sufficient opportunity to review the Privacy Policy, and allow registration only after obtaining consent. All members who complete the registration process are deemed to have agreed to all procedures for collecting and using personal information as stated above."
    },
    {
      "title": "Article 5. Procedures and Methods for Destruction of Personal Information",
      "description":
        "In principle, we promptly destroy personal information once the purpose of processing has been achieved. The procedures and methods of destruction are as follows:\n" +
        "1. Destruction Procedures\n" +
        'a. Information entered by the "user" is transferred to a separate database (or stored separately in the case of paper documents) after the purpose is fulfilled. It is then stored for a certain period in accordance with internal policies and relevant laws, or destroyed immediately. Personal information transferred to the DB will not be used for any other purpose unless required by law.\n' +
        "2. Destruction Methods\n" +
        "a. Information in electronic file format is destroyed using technical methods that make data recovery impossible.\n" +
        "b. Personal information printed on paper is destroyed by shredding or incineration.\n"
    },    
    {
      title: "Article 6. Delegation of Personal Information Processing",
      type: PRIVACY_CONTENT_TYPE.TABLE,
      description:
        "1. To ensure the smooth processing of personal information tasks, we delegate personal information processing tasks as follows." +
        "2. When concluding a delegation contract, we specify in documents such as contracts that the delegatee must comply with Article 26 of the Personal Information Protection Act, which includes prohibiting the processing of personal information for purposes other than those delegated, taking technical and managerial protective measures, restricting re-delegation, managing and supervising the delegatee, and bearing liability for damages. We also supervise the delegatee to ensure they securely process personal information. \n" +
        "3. If there are any changes to the content of the delegated tasks or the delegatee according to this privacy policy, we will promptly disclose such changes through this privacy policy. \n",
      tableContent: [
        {
          company: "Delegatee",
          details: "Details of Delegated Tasks",
        },
        {
          company: "AWS",
          details: "Provision of cloud IT infrastructure",
        },
      ],
    },
    {
      title:
        'Article 7. Rights of "Users" and Legal Representatives and How to Exercise Them',
      description:
        '1. "Users" and legal representatives can view or modify their own personal information or that of children under 14 at any time, and they can request membership termination. When a member sends a withdrawal request email to the customer center, we confirm the member\'s identity before processing the withdrawal. \n' +
        '2. Personal information that has been terminated or deleted at the request of the "user" or legal representative is handled according to the provisions of "Article 5. Retention and Use Period of Personal Information" and cannot be viewed or used for other purposes. \n' +
        "3. When exercising the rights mentioned in paragraph 1 through a legal representative, a power of attorney form according to Form No. 11 of the Enforcement Rules of the Personal Information Protection Act must be submitted. \n" +
        "4. Requests for access to and suspension of processing personal information may be restricted according to Articles 35(5) and 37(2) of the Personal Information Protection Act. Requests for correction and deletion of personal information cannot be made if the personal information is specified as the subject of collection by other laws. \n",
    },
    {
      title:
        " Article 8. Installation, Operation, and Refusal of Automatic Personal Information Collection Devices",
      description:
        "kps uses cookies to store and retrieve user information from time to time to provide personalized services. \n" +
        "Cookies are small pieces of information that a server (http) operating a website sends to the user's computer browser, and they may also be stored on the user's PC hard disk. \n" +
        '1. Purpose of using cookies: Cookies are used to understand the visit and usage patterns, popular search terms, and secure connection status of each service and website visited by the "user" to provide optimized information to the "user." \n' +
        "2. Installation, operation, and refusal of cookies: You can refuse the storage of cookies through option settings in the Privacy menu under Tools > Internet Options at the top of your web browser. \n" +
        "3. If you refuse to store cookies, there may be difficulties in using the service.",
    },
    {
      title:
        "Article 9. Measures to Ensure the Security of Personal Information",
      description:
        "In accordance with Article 29 of the Personal Information Protection Act, we implement the following technical, managerial, and physical measures necessary to ensure the security of personal information. \n" +
        "1. Minimization and Training of Personal Information Handling Staff \n" +
        "a. We designate staff members who handle personal information and limit the management of personal information to these individuals to minimize access and manage data securely. \n" +
        "2. Technical Measures Against Hacking \n" +
        "a. To prevent the leakage and damage of personal information due to hacking or computer viruses, we install security programs, regularly update and check these programs, and install systems in areas with restricted access to monitor and block unauthorized access both technically and physically. \n" +
        "3. Encryption of Personal Information \n" +
        'a. The passwords of "users" are encrypted for storage and management so that only the individual can know them. Important data is encrypted or secured using file locking functions or other separate security features. \n' +
        "4. Restriction of Access to Personal Information \n" +
        "a. We take necessary measures to control access to personal information through granting, changing, and revoking access rights to the database system processing personal information. Unauthorized access from outside is controlled using an intrusion prevention system.\n",
    },
    {
      title: "Article 10. Notice of Changes to the Privacy Policy",
      description:
        "This privacy policy is effective from the date of implementation. In the event of any additions, deletions, or corrections due to changes in laws or policies, we will notify you of these changes at least seven days prior to their implementation through announcements.",
    },
    {
      title:
        "Article 11. Personal Information Management Officer and Contact Information",
      description:
        "We have designated a Personal Information Protection Officer to take overall responsibility for the processing of personal information, handle complaints, and provide relief for damages related to personal information processing as follows: \n" +
        "1. Department in Charge of Personal Information Management: Customer Support Team \n" +
        "a. Email: doazpeople@gmail.com \n" +
        "2. Personal Information Protection Officer \n" +
        "a. Name: Youngtae Kim\n" +
        "b. Phone Number: 02-6204-0139\n" +
        "Members can contact the Personal Information Protection Officer and the department in charge for any inquiries, complaints, or damages related to personal information protection while using our services (kps). \n" +
        "For reporting or consulting on personal information infringement, please contact the following agencies: \n" +
        "Personal Information Infringement Report Center: https://privacy.kisa.or.kr/kor/main.jsp / 118 without area code \n" +
        "Supreme Prosecutors' Office Cyber Crime Investigation Center: http://www.spo.go.kr / 02-3480-2000 \n" +
        "Cyber Safety Bureau of the National Police Agency: http://cyberbureau.police.go.kr / 182 without area code \n" +
        "This policy is effective from March 11, 2025.",
    },
  ],
};
